// Ping al backend cada 8 minutos para evitar que Render free tier se duerma.
// El health endpoint es público y no requiere autenticación.
const PING_INTERVAL_MS = 8 * 60 * 1000;
const HEALTH_URL = (import.meta.env.VITE_API_URL || '/api/v1') + '/health';

export function startKeepAlive() {
  const ping = () => fetch(HEALTH_URL, { method: 'GET' }).catch(() => {});
  ping();
  setInterval(ping, PING_INTERVAL_MS);
}
